// eslint-disable-next-line no-restricted-imports

import React from 'react';
import styled from 'styled-components';
import { spaces } from '@99designs/emu/settings';
import { ObservableField, ObservableForm } from '../../ObservableForm';
import BoxSelect from './BoxSelect';

const Box = styled.div`
    padding: ${spaces['1bu']} 0;
`;

interface Fields {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    [key: string]: any;
}

interface Props<T, K> {
    form: ObservableForm<T>;
    name: K;
    title: string;
    required?: boolean;
    options: React.ComponentProps<typeof BoxSelect>['options'];
    columns?: number;
    subtext?: string | null;
    footnote?: string | null;
}

function BoxSelectField<T extends Fields, K extends keyof T>({
    form,
    name,
    title,
    required,
    options,
    columns,
    subtext,
    footnote,
}: Props<T, K>) {
    return (
        <ObservableField
            form={form}
            name={name}
            title={title}
            required={required}
            message={subtext ?? undefined}
            footnote={footnote ?? undefined}
            render={() => (
                <Box>
                    <BoxSelect options={options} {...form.attach(name, true)} columns={columns} />
                </Box>
            )}
        />
    );
}

export default BoxSelectField;
